import { serviceAwardsURL, cmxURL } from '../endpoints';

function ServiceAwardsService( { access_token } ) {
    const fetchWithAuth = function( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                'authorization': `Bearer ${ access_token }`
            }
        };

        return fetch( url, options );
    };
    const promiseCache = {};

    const cache = ( name, fn ) => {
        return async () => {
            if ( !promiseCache[ name ] ) {
                promiseCache[ name ] = fn();
            }
            return promiseCache[ name ];
        };
    };

    const listPrograms = cache( 'listPrograms', async () => {
        const res = await fetchWithAuth( `${ serviceAwardsURL }/programs`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        } );

        const data = await res.json();

        if ( !res.ok ) {
            throw new Error( data.message );
        }

        let programs = data;
        // if service awards ever changes the response to not be an array
        if ( data.programs ) {
            programs = data.programs;
        }

        // fetch the names for the programs from cmx
        const cmxRes = await fetchWithAuth( `${ cmxURL }/bundle/service-awards`, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify( {
                locales: [ 'en-US' ],
                keys: programs.map( p => `program_${ p.programId }.name` )
            } )
        } );
        const cmxData = await cmxRes.json();
        programs.forEach( p => {
            p.name = cmxData.bundles[ 'en-US' ][ `program_${ p.programId }.name` ] || 'Unknown';
        } );

        return programs;
    } );

    return {
        listPrograms
    };
}

export default ServiceAwardsService;
